import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Input } from '../../../../../common/html/input'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import Tree from '../../../../../common/tree'
import { convertDataTree } from '../../../../../common/tree/helper'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import classes from '../../../../index.module.scss'
import {
  selectIcbChecked,
  selectIcbTree,
  selectVsic,
  setIcb,
  setIcbChecked,
  setIcbTree,
} from '../../../store/slice'

const IcbTree = ({ icbs, customContainerStyle, customTreeStyle }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectIcbChecked)
  const icbTree = useSelector(selectIcbTree)
  const vsicId = useSelector(selectVsic)

  const textSearch = UseI18n('settingPreferences.SEARCH_INDUSTRY')
  const industryUsedMessage = UseI18n('errorCommon.ONE_TYPE_OF_INDUSTRY_USED')

  const [valueSearch, setValueSearch] = useState('')

  const isDisableSelection = !!vsicId.length

  useEffect(() => {
    if (icbs.length) {
      dispatch(setIcbTree(convertDataTree(icbs, 'id', 'parentId')))
    }
  }, [icbs])

  const changeSearch = (e) => setValueSearch(e.target.value)

  const setIcbSelected = (items) => {
    dispatch(setIcb(items))
  }

  const setChecked = (items) => {
    if (isDisableSelection) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [industryUsedMessage],
      })
      return
    }
    dispatch(setIcbChecked(items))
  }

  return (
    <>
      <Input
        placeHolder={textSearch}
        containerStyle={{ height: '28px' }}
        value={valueSearch}
        onChange={changeSearch}
        noControl
      />
      <div className={classes.treeContainer} style={customContainerStyle}>
        {!!Object.keys(icbTree).length && (
          <ScrollComponent>
            <div className={classes.tree}>
              <Tree
                treeData={icbTree}
                idKey="id"
                nameKey="name"
                isHaveCheckbox={true}
                valueSearch={valueSearch}
                listChecked={checked}
                setListChecked={setChecked}
                setListParentChecked={setIcbSelected}
                disabledCheckDbClick
                additionSearchKeys={['name', 'code']}
                customTreeStyle={customTreeStyle}
              />
            </div>
          </ScrollComponent>
        )}
      </div>
    </>
  )
}

IcbTree.propTypes = {
  icbs: PropTypes.array.isRequired,
}

export default IcbTree
